import { z } from 'zod';

export const recomputeClipTimingDataSchema = z.object({
  startMs: z.number(),
  endMs: z.number(),
  durationMs: z.number(),
  needsManualCrop: z.boolean(),
  changed: z.boolean(),
});

export type IRecomputeClipTimingData = z.infer<typeof recomputeClipTimingDataSchema>;
